import { url } from "../../url/url.link"

export default async function EditDataAD({token,datosU}) {
  const listaCuenta = await fetch(url+'/ariztia/sueditcta',{
    method: 'POST',
    headers: {
      'authorization': token,
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      data: datosU
    })
  })
  
  let lista = await listaCuenta.json()
  if(!lista.data.success)window.location.href='/salir'
  return lista
}
